/** @jsx jsx */

import { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';
import { MultichoiceContext } from './Multichoice_v2';
import EditableBtn from 'components/lib/EditableBtn';

const SubmitBtn = props => {
  const { children } = props;

  const multichoiceContext = useContext(MultichoiceContext);

  const { isLive, onSubmit } = (multichoiceContext as any) || {};

  return (
    <div
      css={css`
        margin-top: 20px;
        ${!window.dev() &&
          `
          opacity: ${isLive ? 1 : 0};
          pointer-events: ${isLive ? 'auto' : 'none'};
          transition: opacity 0.2s;
        `}
      `}
    >
      <EditableBtn {...{ enabled: !!isLive, ...props }} onClick={onSubmit}>
        {children}
      </EditableBtn>
    </div>
  );
};

export default SubmitBtn;
